import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

// On a vessel record that came from the management company's library (fleet-3, sql/fleet-3.sql company_standard_copies): which standard
// and version, and what the Master does with it. A checklist has no status, so its copy is accepted here (hc_standard_accept: the
// Captain on board, never management). Nothing is shown for an ordinary record, or before sql/fleet-3.sql has run.
export default function CompanyStandardNote({ kind, localId, style }) {
  const { config } = useAuth()
  const [x, setX] = useState(null)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [tick, setTick] = useState(0)
  useEffect(() => {
    let live = true
    setX(null)
    if (localId) supabase.from('company_standard_copies').select('id,version,kind,accepted_by,accepted_at,sent_by,sent_at,company_standards(code,title,current_version)').eq('local_id', localId).order('version', { ascending: false }).limit(1)
      .then(r => { if (live && !r.error && r.data && r.data[0]) setX(r.data[0]) }, () => {})
    return () => { live = false }
  }, [localId, tick])
  if (!x || (kind && x.kind !== kind)) return null
  const s = x.company_standards || {}
  const from = x.sent_by || 'the management company'
  const manager = !!(config && (config._companyView || config.accountType === 'company'))
  async function accept() {
    setBusy(true); setErr('')
    const { error } = await supabase.rpc('hc_standard_accept', { p_copy: x.id })
    setBusy(false)
    if (error) setErr(String(error.message || error)); else setTick(t => t + 1)
  }
  const how = x.kind === 'ra' ? 'The Master reviews it and sets it Active.' : x.kind === 'checklist' ? 'The Master reviews the steps and accepts it on board.' : 'The Master (Full on Manuals) reviews it and approves it.'
  return (
    <div role="note" data-company-standard={s.code || ''} style={{ border: '1px solid var(--border, #d9dee6)', borderLeft: '3px solid var(--gold2, #c9a84c)', borderRadius: 8, padding: '9px 12px', margin: '8px 0', fontSize: 12.5, lineHeight: 1.45, color: 'var(--text)', background: 'var(--card, transparent)', ...style }}>
      <b>Company standard {s.code || ''} &middot; v{x.version}</b> from {from}.{' '}
      {x.kind === 'checklist' && x.accepted_at ? <span>Accepted on board by {x.accepted_by}.</span> : <span style={{ color: 'var(--muted)' }}>{how}{x.version > 1 ? ' Setting it active archives the older version on board.' : ''}</span>}
      {s.current_version > x.version && <span style={{ color: 'var(--muted)' }}> A newer version (v{s.current_version}) exists in the company library.</span>}
      {manager && <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 3 }}>Management sends standards; only the Master on board sets them active.</div>}
      {x.kind === 'checklist' && !x.accepted_at && !manager && (
        <div style={{ marginTop: 7 }}>
          <button onClick={accept} disabled={busy} style={{ background: 'var(--gold2, #c9a84c)', color: '#1b1b1b', border: 'none', borderRadius: 7, padding: '7px 13px', fontWeight: 700, fontSize: 12.5, cursor: 'pointer', fontFamily: 'inherit' }}>{busy ? 'Accepting…' : 'Accept on board'}</button>
          {err && <span style={{ color: 'var(--red, #c93b47)', marginLeft: 10, fontSize: 12 }}>{err}</span>}
        </div>)}
    </div>
  )
}
